/**
 * HTML Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const HtmlDetector: ITypeDetector = {
  id: 'html-detector',
  name: 'HTML Detector',
  priority: 70, // Higher than XML since HTML is more specific
  detectedType: SEMANTIC_TYPES.HTML,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim().toLowerCase();
    
    // Check for DOCTYPE
    if (trimmed.startsWith('<!doctype html')) {
      return SEMANTIC_TYPES.HTML;
    }

    // Check for common HTML tags
    const htmlPatterns = [
      /^<html[\s>]/i,
      /^<head[\s>]/i,
      /^<body[\s>]/i,
      /<html[\s>]/i,
      /<head[\s>]/i,
      /<body[\s>]/i,
      /<div[\s>]/i,
      /<span[\s>]/i,
      /<p[\s>]/i,
      /<a\s+href/i,
      /<img\s+src/i,
      /<script[\s>]/i,
      /<style[\s>]/i,
      /<link[\s>]/i,
      /<meta[\s>]/i,
    ];

    const inputLower = input.toLowerCase();
    
    // Must start with a tag
    if (!input.trim().startsWith('<')) {
      return null;
    }

    // Check for multiple HTML-specific patterns
    let matchCount = 0;
    for (const pattern of htmlPatterns) {
      if (pattern.test(inputLower)) {
        matchCount++;
        if (matchCount >= 2) {
          return SEMANTIC_TYPES.HTML;
        }
      }
    }

    // Check for <html> tag specifically
    if (/<html[\s>]/i.test(inputLower) || /<!doctype/i.test(inputLower)) {
      return SEMANTIC_TYPES.HTML;
    }

    return null;
  },
};
